import React,{ useState, useEffect } from 'react';

import trait from './../../assets/images/trait.svg';
import loupe from './../../assets/images/loupe.svg';
import bigFeuille from './../../assets/images/bigfeuille-bg.png';
import imageFlavescence from './../../assets/images/illustration-flavescence-doree.jpg';
import picto_carte from  './../../assets/images/picto-carte.svg';
import iconSearch from './../../assets/images/search-commune.svg';

import ActualiteSevice from "../../service/ActualiteSevice";
import Diaporama from "./Diaporama";
import {RechercheIntro} from "./RechercheIntro";

export const HomeIntro = ({
                              openDownloadModal
                          }) => {

    const[actualites, setActualites] = useState([]);
    const[loadingActualites, setLoadingActualites] = useState(1);
    const fetchActualites = async() => {
        try{
            const data = await ActualiteSevice.findAll();
            setActualites(data);
            setLoadingActualites(false);
        }catch (error){

        }
    }

    useEffect(() => {
        fetchActualites();
    }, []);

    return (
            <>
                <section className="hero-section position-relative bg-light d-flex align-items-center overflow-hidden">

                    <div className="container-hero container-fluid p-0 h-100">
                        <div className="row g-0 h-100">

                            <div className="col-lg-6 position-relative d-flex align-items-center justify-content-center p-4 p-md-5">
                                <div className="position-absolute top-0 start-0 w-100 h-100 bg-hero-left" style={{ background: `linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65)), url(${imageFlavescence}) center/cover no-repeat` }}>

                                </div>
                                <div className="col-xxl-10 translate-x-hero-1">

                                    <img src={trait} className="position-absolute bottom-0 start-0 m-4 d-none d-md-block" style={{ width: '120px', zIndex: 2 }} />

                                        <div className="position-relative text-white text-lg-start text-center my-auto pt-lg-4 pb-2 pb-lg-4 px-lg-4" style={{ zIndex: 3, maxWidth: '540px' }}>
                                            <h1 className="display-4 fw-sb mb-4">Stop <br />Flavescence</h1>
                                            <p className="lead fs-4 lh-normal">
                                                <strong>Une gestion aménagée de la Flavescence Dorée</strong> grâce à une analyse de risque précise et une mobilisation de la profession exemplaire.
                                            </p>
                                        </div>
                                </div>
                            </div>

                            <div className="col-lg-6 position-relative d-flex align-items-center justify-content-center pb-0 p-4 pb-md-5p-md-5">
                                <div className="position-absolute left-0 top-50 translate-middle-y p-5">
                                    <img src={bigFeuille} alt="Feuilles" className="w-75 h-75 object-fit-contain"/>
                                </div>
                                {actualites.length > 0 && <Diaporama newsData={actualites} />}
                            </div>
                        </div>
                        <RechercheIntro
                            openDownloadModal={openDownloadModal}
                        />
                    </div>
                </section>
            </>
    );
}